import axios from 'axios'
import * as Cookies from 'tiny-cookie'
import Keycloak from 'keycloak-js'
import store from '@/store/index'

class KeycloakAuthServer {
  authenticated = false

  keycloak = undefined

  tokenRefreshTimer = undefined

  constructor (authServer, authRealm, authClientId) {
    axios.defaults.withCredentials = true
    const conf = {
      /* --------------------------------------------------------------------------
        Global variables AUTH_REALM, AUTH_SERVER, AUTH_CLIENT_ID
        are set in the index.html <script> by backend from environmental variables
      ----------------------------------------------------------------------------- */

      // eslint-disable-next-line no-undef
      realm: authRealm, // 'FlexLink',

      // eslint-disable-next-line no-undef
      url: authServer, // 'http://172.28.1.41:7081/auth',

      // eslint-disable-next-line no-undef
      clientId: authClientId, // 'fct',

      checkLoginIframe: false
    }
    this.keycloak = new Keycloak(conf)
  }

  async init () {
    console.log('[DEBUG] auth.js.init')
    return new Promise((resolve) => {
      this.keycloak.init({ onLoad: 'login-required' })
        .then(authenticated => {
          console.log('[DEBUG] authenticated', authenticated)
          if (authenticated) {
            console.log('[DEBUG] Login success')
            this.setAccessToken(this.keycloak.token)
            resolve(true)
          } else {
            console.log('[INFO] Login failed')
            this.removeAccessToken()
            resolve(false)
          }
          return authenticated
        }).catch(e => {
          // errorHandler(e)
          console.log('[ERROR] Failed to initialize Keycloak:', e)
          this.removeAccessToken()
          resolve(false)
        })
    })
  }

  updateAccessToken () {
    // renew token if it expires within two minutes
    const server = this
    this.keycloak.updateToken(120)
      .then((refreshed) => {
        if (refreshed) {
          console.log('[DEBUG] Token was successfully refreshed')
          server.setAccessToken(server.keycloak.token)
        } else {
          console.log('[DEBUG] Token is still valid')
        }
      }).catch(e => {
        console.log('[ERROR] Failed to refresh the token, or the session has expired. Signing out.', e)
        server.signOut()
      })
  }

  getTokenParsed () {
    return this.keycloak.tokenParsed
  }

  setAccessToken (newToken) {
    this.authenticated = true
    Cookies.set('auth_token', newToken)
    // renew the access token every minute
    if (this.tokenRefreshTimer) {
      clearInterval(this.tokenRefreshTimer)
    }
    console.log('[DEBUG] Setting interval for updateAccessToken')
    this.tokenRefreshTimer = setInterval(this.updateAccessToken.bind(this), 60000)
  }

  removeAccessToken () {
    this.authenticated = false
    Cookies.remove('auth_token')
    if (this.tokenRefreshTimer) {
      clearInterval(this.tokenRefreshTimer)
    }
  }

  signOut () {
    this.removeAccessToken()
    this.keycloak.logout()
  }
}

class User {
  name = ''
  preferred_username = ''
  email = ''
  roles = ['viewer']
  groups = []
  external = false

  populateFromToken (tokenParsed) {
    this.name = tokenParsed.name || this.name
    this.preferred_username = tokenParsed.preferred_username || this.preferred_username
    this.email = tokenParsed.email || this.email
    this.roles = tokenParsed.user_roles || this.roles
    this.groups = tokenParsed.groups || this.groups
    this.external = ![
      'oo_sales_unit',
      'oo_sector_group',
      'oo_sales_unit_no_order',
      'oo_sales_unit_admin',
      'oo_sector_group_admin',
      'oo_business_unit',
      'oo_business_unit_supplier_admin',
      'oo_business_unit_admin',
      'oo_administrator'
    ].includes(this.groups[0]) && !this.roles.includes('rc_demo_user')
    store.commit('environment/USER_UPDATED', this)
  }

  isInRole (role) {
    return this.roles.indexOf(role) > -1
  }
}

const auth = {

  server: undefined,

  user: new User(),

  signOut: () => {
    console.log('[DEBUG] auth.signOut:', auth.server)
    if (auth.server) {
      auth.server.signOut()
    }
    auth.user = new User()
  },
  /*
  valid: (token) => {
    const decoded = jwtDecode(token)
    return Date.now() / 1000 <= decoded.exp
  },
  */
  init: async (settings) => {
    console.log('[DEBUG] auth.init:', settings)
    if (!settings || !settings.authServer || settings.authServer === '') {
      return true
    }
    auth.server = new KeycloakAuthServer(settings.authServer, settings.authRealm, settings.authClientId)
    await auth.server.init()
    const authenticated = auth.server.authenticated
    if (authenticated) {
      auth.user.populateFromToken(auth.server.getTokenParsed())
    }
    return authenticated
  }
}

export default auth
